import { CheckCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui'

export function ApproveNoChangesDialog({
  open,
  phaseName,
  checkFailed = false,
  isApproving,
  onCancel,
  onConfirm,
}: Readonly<{
  open: boolean
  phaseName?: string | null
  checkFailed?: boolean
  isApproving?: boolean
  onCancel: () => void
  onConfirm: () => void
}>) {
  return (
    <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && onCancel()}>
      <DialogContent data-testid="approve-no-changes-modal">
        <DialogHeader>
          <DialogTitle className="pb-2">{checkFailed ? 'Approve without checking staged changes?' : 'Approve with no changes?'}</DialogTitle>
          <DialogDescription>
            {checkFailed
              ? 'Could not check whether any changes are staged. Only staged changes are applied, so approving may apply nothing and lets the workflow continue'
              : 'No changes are staged in this change set. Approving applies nothing and lets the workflow continue'}
            {phaseName ? <> past &ldquo;{phaseName}&rdquo;</> : null}. To stop the workflow instead, use Reject.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>Cancel</Button>
          <Button variant="ghost" className="text-success-foreground" disabled={isApproving} onClick={onConfirm}>
            <CheckCircle className="mr-1 h-3 w-3" /> Approve anyway
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
